import { render } from "./NovaFibraTeste.vue?vue&type=template&id=6aa47d2c&scoped=true"
import script from "./NovaFibraTeste.vue?vue&type=script&lang=js"
export * from "./NovaFibraTeste.vue?vue&type=script&lang=js"

import "./NovaFibraTeste.vue?vue&type=style&index=0&id=6aa47d2c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa47d2c"]])

export default __exports__